export const dataTestid = {
    SIDEBAR_AUDIENCE: 'sidebar-audience',
    SIDEBAR_QUESTION: 'sidebar-question-builder',
    SIDEBAR_HOME: 'sidebar-home',
    SLIDER: 'slider',
    CUSTOM_SCREENER_BTN: 'custom-screener-btn',
    TARGETING_OPTION_BTN: 'targeting-option-btn',
    CUSTOM_SCREENER_REDIRECT: 'custom-screener-redirect',
    MODAL_DONE_BTN: 'modal-done-btn',
    MENU_INCA_PANEL: 'menu-inca-panel',
    LIBRARY_BTN: 'library-btn',
    INPUT_RADIO: 'input-radio',
    NEW_QUESTION_BTN: 'new-question-btn',
    QUESTION_MODAL_DONE: 'question-modal-done',
    PROJECT_TYPE_BTN: 'build-from-scratch',
    PROJECT_TYPE_BTN_2: 'rbc-video-ad-evaluation',
    VIDEO_DURATION_INPUT: 'video-duration-input',
    PROCEED_TO_CHECKOUT_MAIN: 'proceed-to-checkout-main',
    NEW_PROJECT_BTN: 'new-project-button',
    PROJECT_CARD_DROPDOWN: 'project-card-dropdown',
    ARCHIVE_PROJECT: 'archive-project'
};
